module.exports = __webpack_public_path__ + "static/img/logo_gold.634c542.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_gold.png
// module id = Ft6Q
// module chunks = 19